import { createSlice } from '@reduxjs/toolkit';

export const docDriversSlice = createSlice({
  name: 'docDrivers',
  initialState: {
    docDrivers: {},
  },
  reducers: {
    addDocDriver: (state, action, nameTwo) => {
      state.docDrivers[action.payload.name] = action.payload.payload
    },
  },
});

export const { addDocDriver } = docDriversSlice.actions;

export const selectDocDriver = state => state.docDrivers.docDrivers;

export default docDriversSlice.reducer;
